import { deleteField, doc } from 'firebase/firestore'
import _ from 'lodash'
import { dispatchProps } from '../../../cnr/reducers/reducerHelpers/dispatchProps'
import { _deleteItemProps, dataFix } from "../../../common/dataFix"
import { removeFromObjects } from '../../../common/sorting'
import { createRefPath, createRefPath_client, createRefPath_event } from "../../appData/appRefPaths"

const _allowDocumentUpdates = false
const _documentDocName = '_documents'

export const updateDocumentHelpers = {
  delete_itemInDocuments: (database_fns, documentCollection, selectedItems, pathViews) => delete_itemInDocuments(database_fns, documentCollection, selectedItems, pathViews),
  /**
 * gets all the documents in the _documents collection
 * @param {*} pathViews 
 * @param {*} callback 
 */
  get_allDocuments: (database_fns, pathViews, callback) => get_allDocuments(database_fns, pathViews, callback),
  /**
   * Update the _documents collection. One document from key. Each true document in the document will be a field
   * @param {*} pathViews 
   * @param {*} documentsData  
   */
  update_allDocuments: (database_fns, pathViews, documentsData) => update_allDocuments(database_fns, pathViews, documentsData),
  update_dataToDocument: (database_fns, pathViews, collection_pk, data, dataRestrictions, dispatch) => update_dataToDocument(database_fns, pathViews, collection_pk, data, dataRestrictions, dispatch),
  update_dataToDocuments: (database_fns, pathViews, dataCollections, dispatch) => update_dataToDocuments(database_fns, pathViews, dataCollections, dispatch),
  update_itemInDocuments: async (batch, database_fns, pathViews, documentName, documentKey, itemData, callback, allowUpdate) => update_itemInDocuments(batch, database_fns, pathViews, documentName, documentKey, itemData, callback, allowUpdate),
  update_itemsInDocument: (database_fns, pathViews, documentName, data, allowUpdate) => update_itemsInDocument(database_fns, pathViews, documentName, data, allowUpdate),
}

const get_allDocuments = (database_fns, pathViews, callback) => {
  const _refPath = createRefPath_event(pathViews, [_documentDocName])
  database_fns.get_data({ refPath: _refPath, callback, opts: { ignoreId: true } })
}

const update_itemInDocuments = (batch, database_fns, pathViews, documentName, documentKey, dataToUpdate, callback, allowUpdate) => {
  const baseRef = createRefPath_event(pathViews)
  const _refPathDoc = createRefPath([_documentDocName, documentName], baseRef)
  const _dataToUpdate = dataFix.removeUnderscoreKeys(dataToUpdate)
  // docToUpdate will only include the document key and the field being updated.
  // this will only update the documentKey of the document keys array
  const docToUpdate = {
    [documentKey]: _dataToUpdate
  }
  if (allowUpdate) {
    if (batch) {
      const xxx = doc(_refPathDoc)
      batch.set(xxx, dataToUpdate, { merge: true })
    } else {
      if (_allowDocumentUpdates) {
        database_fns.set_doc(_refPathDoc, docToUpdate, true, callback)
      }
    }
  } else {
    console.group('ℹ️ update_itemInDocuments', documentName)
    console.log('documentKey', documentKey, _refPathDoc)
    console.log('docToUpdate', docToUpdate)
    console.groupEnd()
  }
}

const update_itemsInDocument = (database_fns, pathViews, documentName, data, allowUpdate) => {
  const baseRef = createRefPath_event(pathViews)
  const _refPathDoc = createRefPath([_documentDocName, documentName], baseRef)
  const docsToUpdate = {}
  const _data = dataFix.cleanDocumentsData(data)
  _.forEach(_data, (itemData, itemKey) => {
    const dtu = dataFix.createDeleteFields(itemData)
    delete dtu.element
    docsToUpdate[itemKey] = dtu
  })
  if (allowUpdate) {
    database_fns.update_docc({
      refPath: _refPathDoc,
      data: docsToUpdate,
    })
    // database_fns.update_doc(_refPathDoc, docsToUpdate)
  } else {
    console.log('update_itemsInDocument', _refPathDoc, docsToUpdate)
  }
}

const delete_itemInDocuments = (database_fns, documentCollection, selectedItems, pathViews) => {
  const baseRef = createRefPath_event(pathViews)
  const _refPathDoc = createRefPath([_documentDocName, documentCollection], baseRef)
  const docsToUpdate = {}
  _.forEach(selectedItems, (selectedItem, itemKey) => {
    docsToUpdate[itemKey] = deleteField()
  })
  if (_allowDocumentUpdates) {
    // database_fns.update_doc(_refPathDoc, docsToUpdate)
    database_fns.update_docc({
      refPath: _refPathDoc,
      data: docsToUpdate,
    })
  } else {
    console.log('delete_itemInDocuments', _refPathDoc, docsToUpdate)
  }
}

const update_dataToDocuments = async (database_fns, pathViews, dataCollections, dispatch) => {

  const updateDocuments = () => {
    const promises = []

    Object.keys(dataCollections).forEach(key => {
      promises.push(update_dataToDocument(database_fns, pathViews, key, dataCollections[key]))
    })

    return Promise.all(promises)
  }

  await updateDocuments()
  dispatch && dispatch({ type: dispatchProps.successAlt, dispatch })

}

const update_dataToDocument = async (database_fns, pathViews, collection_pk, data, dataRestrictions, dispatch) => {

  const _data = _.cloneDeep(data)
  removeFromObjects(_data, ['_itemKey', 'id', 'key', '_new', '_changed', '_sv', '_dateInfo'])

  const _useDeepDoc = true

  // 
  // const documentData = { ... _data }
  const documentData = _useDeepDoc ? _data : { [collection_pk]: _data }
  const documentName = _useDeepDoc ? collection_pk : '_' + collection_pk

  let _allow = true

  if (dataRestrictions && dataRestrictions.createSingleDocument) {
    _allow = false
  }

  const _refPath = pathViews.events ? createRefPath_event(pathViews, [documentName, collection_pk]) : createRefPath_client(pathViews, [documentName, collection_pk])
  const _refPathDeep = pathViews.events ? createRefPath_event(pathViews, [_documentDocName, documentName]) : createRefPath_client(pathViews, [_documentDocName, documentName])

  if (!_allow) {
    if (_useDeepDoc) {
      console.log('update_dataToDocument', _refPathDeep, documentData)
    } else {
      console.log('update_dataToDocument', _refPath, documentData)
    }
    dispatch && dispatch({ type: dispatchProps.successAlt, dispatch })
    return false
  } else {
    if (_useDeepDoc) {
      database_fns.set_doc(_refPathDeep, documentData, true, dispatch)
    } else {
      database_fns.set_doc(_refPath, documentData, true, dispatch)
    }
  }

  return false

}

const update_allDocuments = async (database_fns, pathViews, documentsData) => {
  const xxx = await updateDocumentsPromise(database_fns, pathViews, documentsData)
  return xxx
}

/**
 * 
 * @param {*} pathViews 
 * @param {*} documentsData 
 * @returns 
 */
const updateDocumentsPromise = (database_fns, pathViews, documentsData) => {
  const promises = []
  _.forEach(documentsData, (documentData, documentKey) => {
    const _refPathDoc = createRefPath_event(pathViews, [_documentDocName, documentKey])
    const docToUpdate = {}
    _.forEach(documentData, (data, itemKey) => {
      docToUpdate[itemKey] = dataFix.removeKeys(data, [..._deleteItemProps])
    })
    if (_allowDocumentUpdates) {
      console.log('updateDocumentsPromise', _refPathDoc, _.size(docToUpdate), docToUpdate)
      promises.push(database_fns.set_doc(_refPathDoc, docToUpdate))
    } else {
      console.log('updateDocumentsPromise', _refPathDoc, _.size(docToUpdate), docToUpdate)
    }
  })
  return Promise.all(promises)
}
